import { connect } from "react-redux";
import SiteInspectionChecklistList from "./site-inspection-checklist-list";
import {
    onRemove,
    onSiteInspectionChecklistSearchChanged,
    onSiteInspectionChecklistPagedListRequest,
} from "features/health-and-safety/actions";
import { onPagedListRequested as onSitesPagedListRequested } from "features/sites/actions";

const mapStateToProps = ({ healthSafety, profile, organisations, sites }) => ({
    siteInspectionChecklists: healthSafety.siteInspectionChecklists,
    role: profile.role,
    searchFilter: healthSafety.searchFilter,
    currentOrganisationGUID: organisations.currentOrganisation?.id || organisations.currentOrganisation,
    sites: sites.pagination
});

const mapDispatchToProps = {
    onDelete: onRemove,
    onSearchChanged: onSiteInspectionChecklistSearchChanged,
    onGetSiteInspectionChecklistsList: () => {
        console.log("Container: Dispatching SITE_INSPECTION_CHECKLIST_PAGED_LIST_REQUESTED action");
        
        // Log if we're navigating between pages
        let isNavigating = false;
        try {
            // Check if we are in the middle of a navigation event
            const currentNavState = window.history.state;
            if (currentNavState && currentNavState.__navigating) {
                isNavigating = true;
                console.log("Navigation in progress, request might be interrupted");
            }
        } catch (e) {
            console.warn("Unable to check navigation state:", e);
        }
        
        // Check if we're viewing a site-specific page
        let isSiteSpecific = false;
        let siteId = null;
        try {
            // Check URL to see if we're in a site-specific view
            const pathname = window.location.pathname;
            const siteIdMatch = pathname.match(/\/sites\/([a-zA-Z0-9-]+)/);
            if (siteIdMatch && siteIdMatch[1]) {
                isSiteSpecific = true;
                siteId = siteIdMatch[1];
                console.log("Site-specific view detected, site ID:", siteId);
            } else {
                console.log("Global checklist library view detected");
            }
        } catch (e) {
            console.warn("Unable to check if site-specific view:", e);
        }
        
        // Log organization info from localStorage if available
        let hasAuthToken = false;
        try {
            const token = localStorage.getItem("token");
            hasAuthToken = !!token;
            console.log("Auth token exists:", hasAuthToken);
            
            // Alternative method to find organization info
            const organisationInfo = localStorage.getItem("organisation");
            if (organisationInfo) {
                try {
                    const org = JSON.parse(organisationInfo);
                    console.log("Organization from localStorage:", org);
                } catch (e) {
                    console.error("Error parsing organization from localStorage:", e);
                }
            }
            
            const userInfo = localStorage.getItem("user");
            if (userInfo) {
                const parsedUser = JSON.parse(userInfo);
                console.log("User info from localStorage:", {
                    hasToken: hasAuthToken,
                    hasOrgInfo: !!parsedUser?.organisation,
                    orgId: parsedUser?.organisation?.id,
                    orgGuid: parsedUser?.organisation?.guid
                });
            } else {
                console.log("No user info in localStorage");
            }
        } catch (e) {
            console.error("Error reading localStorage:", e);
        }
        
        // Enhanced payload with timestamp to avoid caching
        return onSiteInspectionChecklistPagedListRequest({ 
            pageNumber: 1, 
            pageSize: 50,
            timestamp: new Date().getTime(),
            __cancelled: isNavigating, // Set cancelled flag if we're navigating
            isSiteSpecific: isSiteSpecific, // Add flag to indicate if we need site filtering
            siteId: siteId // Include the site ID if this is a site-specific view
        });
    },
    onEmail: () => console.log("Email site inspection checklist"),
    onGetSitesList: () => onSitesPagedListRequested({ pageNumber: 1, pageSize: 1000 })
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteInspectionChecklistList); 